export default {
  dashboard: {
    title: "Dashboard",
    common: {
      back: "Back",
      welcome: "Welcome {name}",
      days: "day{days, plural, =0 {} =1 {} other{s}}",
      specialist: {
        title: "Your Specialist Package",
        titleV2: "Area & Condo Specialist Packages",
        emptyDescription: "You have no Specialist package.",
        viewMoreDetail: "View more details on your specialist package.",
        viewPackage: "View package",
        viewAllPackages: "View all packages",
        viewFullDetails: "View full details",
        upgradeNow: "Upgrade now",
        upgradeListing:
          "Upgrade your listing to minimum {productCount} {productDescription} listings to continue with the specialist package.",
        pleaseNote: "Please note",
        profileOrLicenseRequired:
          "Profile picture or license number is required to qualify as a specialist.",
        minimum1ActiveListing:
          "Ensure that you have a minimum of 1 active listing to continue with the specialist package.",
        bookNow: "Book now",
      },
      subscription: {
        title: "Subscription",
        remainingBalance: "Your remaining balances",
        listings: "Listings",
        tabTitle: "Subscriptions",
        adCredit: "Ad Credits",
        featureCredit: "Featured Credits",
        expiry: "Package expiry date:",
        viewSubscription: "View subscription",
        viewSubscriptionAndRemainingBalances:
          "View subscription and remaining balances",
        contractDescription:
          'Contract will expire on <span class="date">{expiryDate}</span>',
        noSubscription: {
          message: `Please contact our Customer Service Team via <a href="mailto:sf.info@rea-group.com">sf.info@rea-group.com</a>,  <a href="https://wa.me/85297636898" rel="noopener noreferrer" target="_blank">
          +852 97636898
      </a> (WhatsApp) or   <a href="tel:+85231981818" rel="noopener noreferrer">
                  +852 3198 1818
              </a> (call hotline).`,
          title: "Your contract details cannot be displayed.",
        },
        remaining: {
          label: "Remaining",
        },
        duration: {
          label: "Duration",
          unit: "days",
        },
        used: {
          label: "Used",
        },
        total: {
          label: "Total",
        },
        tier: {
          label: "Tier",
        },
        contractTitle: {
          myContract: "My contract",
          agency: "Agency contract",
          branch: "Branch contract",
        },
      },
      allocation: {
        title: "Allocation",
        remainingBalance: "Your remaining balances",
        expiry: "Expiration date:",
        tabTitle: "Allocations",
        contractDescription:
          'Contract will expire on <span class="date">{expiryDate}</span>',
        remaining: {
          label: "Remaining",
        },
        duration: {
          label: "Duration",
          unit: "days",
        },
        used: {
          label: "Used",
        },
        total: {
          label: "Total",
        },
        tier: {
          label: "Tier",
        },
        contractTitle: {
          myContract: "My contract",
          agency: "Agency contract",
          branch: "Branch contract",
        },
        noAllocation: {
          message:
            "To get access, please contact your Account Manager or Customer Service Team.",
          title: "Allocations are disabled.",
        },
        noStandardCreditBalance: {
          message:
            "No standard credit left, you can only upgrade existing listings to Premium or Feature tier.",
        },
        noCreditBalance: {
          message: "No allocations left.",
        },
      },
      agentsPerformance: {
        title: "Agents Performance",
        hongkongTitle: "Your performance",
        impressions: "Impressions",
        pageViews: "Page views",
        enquiries: "Enquiries",
        viewFullReporting: "View full reporting",
      },
      brickzAccess: {
        title: "Brickz Access",
        remainingDays:
          "<span class='days'>{days}</span> <span class='label'>day{days, plural, =0 {} =1 {} other{s}} left</span>",
        validUntil: "Valid until {date}",
        expired: "Contact Account Manager to purchase Brickz add-on",
        buyBrickz: "Buy Brickz add-on now!",
      },
      accountManager: {
        title: "Your Account Manager",
        phone: "Phone",
        did: "DID",
        general: "General",
        workHour: "Work hours",
        workHourDetail: "Mon to Fri, 9am - 6pm",
      },
      announcement: {
        title: "Announcements",
        viewAll: "View all announcements",
        showMore: "Show more",
      },
      emptyHeader: "You have no alert created yet.",
      emptySubHeader: "Once you created an alert, it’ll appear here.",
      NoSubscription: {
        title: "You are not subscribed to any package.",
        body: "Please contact your Account Manager or Customer Service Team via:",
        whatsapp: "WhatsApp",
        hotline: "Hotline",
        email: "Email",
      },
      customerExperienceTeam: {
        header: "Get support",
        title: "Customer Experience Team",
        whatsapp: "WhatsApp",
        phone: "Phone",
        workHours: "Work hours: Mon to Fri, 9am - 6pm",
        email: "Email",
        hkWorkHours: {
          label: "Work hours",
          title: "Mon to Fri, 9am - 6pm (Except Public Holidays)",
        },
        description: `
        By clicking the displayed WhatsApp number, you agree to receive messages from “+852 97636898” over WhatsApp and to our `,
        PICSLink: "Personal Information Collection Statement.",
        collapsedDescription: `You accept REA Hong Kong Management Co. Limited (REA HK)’s <a href="https://www.squarefoot.com.hk/en/terms-of-use/" rel="noopener noreferrer" target="_blank">Terms of Use </a>
      and <a href="https://www.squarefoot.com.hk/en/privacy/" rel="noopener noreferrer" target="_blank">Privacy Policy</a> including REA HK’s collection, use, disclosure, processing, handling and storage of your Personal Information. “Personal Information” may include name and telephone number.`,
      },
    },
    expirySubscription: {
      description:
        "Your iProperty Pro subscription will expire on <b>{value}</b>.<br/>Your access will be suspended and listings will be taken offline if not addressed. <br/>If you have renewed, please ignore this message.",
      hideMessage: "Hide this message",
    },
    pendingScheduled: "<b>*{number}</b> Pending scheduled readvertise",
  },
};
